import type { ReactElement, SVGProps } from 'react';

const base: SVGProps<SVGSVGElement> = {
  width: 20,
  height: 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export type IconProps = SVGProps<SVGSVGElement>;
export type IconComponent = (p: IconProps) => ReactElement;

export const PlannerIcon: IconComponent = (p) => (
  <svg {...base} {...p}>
    <rect x="3" y="5" width="18" height="15" rx="3" />
    <path d="M3 10h18" />
    <path d="M8 3v4M16 3v4" />
  </svg>
);
export const BellIcon: IconComponent = (p) => (
  <svg {...base} {...p}>
    <path d="M6 8a6 6 0 1 1 12 0c0 5 2 6 2 6H4s2-1 2-6Z" />
    <path d="M10 19a2 2 0 0 0 4 0" />
  </svg>
);
export const BuildingIcon: IconComponent = (p) => (
  <svg {...base} {...p}>
    <rect x="4" y="3" width="16" height="18" rx="2" />
    <path d="M9 8h2M13 8h2M9 12h2M13 12h2M9 16h2M13 16h2" />
  </svg>
);
export const UserIcon: IconComponent = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21a8 8 0 0 1 16 0" />
  </svg>
);
export const ChatIcon: IconComponent = (p) => (
  <svg {...base} {...p}>
    <path d="M21 12a8 8 0 1 1-3.2-6.4L21 4l-1 4.2A8 8 0 0 1 21 12Z" />
    <circle cx="12" cy="12" r="0.8" fill="currentColor" stroke="none" />
  </svg>
);
export const ChecklistIcon: IconComponent = (p) => (
  <svg {...base} {...p}>
    <path d="M4 6l2 2 3-3" />
    <path d="M4 13l2 2 3-3" />
    <path d="M4 20l2 2 3-3" />
    <path d="M12 6h9M12 13h9M12 20h9" />
  </svg>
);
export const NoteIcon: IconComponent = (p) => (
  <svg {...base} {...p}>
    <path d="M6 3h9l5 5v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" />
    <path d="M15 3v5h5" />
  </svg>
);
export const SunIcon: IconComponent = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4 7 17M17 7l1.4-1.4" />
  </svg>
);
export const DatabaseIcon: IconComponent = (p) => (
  <svg {...base} {...p}>
    <ellipse cx="12" cy="5.5" rx="8" ry="2.5" />
    <path d="M4 5.5v6c0 1.4 3.6 2.5 8 2.5s8-1.1 8-2.5v-6" />
    <path d="M4 11.5v6c0 1.4 3.6 2.5 8 2.5s8-1.1 8-2.5v-6" />
  </svg>
);
export const TreeIcon: IconComponent = (p) => (
  <svg {...base} {...p}>
    <rect x="4" y="3" width="6" height="4" rx="1" />
    <rect x="14" y="10" width="6" height="4" rx="1" />
    <rect x="14" y="17" width="6" height="4" rx="1" />
    <path d="M7 7v5h7M7 12v7h7" />
  </svg>
);
export const ChevronRight: IconComponent = (p) => (
  <svg {...base} {...p}><path d="M9 6l6 6-6 6" /></svg>
);
export const ChevronDown: IconComponent = (p) => (
  <svg {...base} {...p}><path d="M6 9l6 6 6-6" /></svg>
);
export const ChevronLeft: IconComponent = (p) => (
  <svg {...base} {...p}><path d="M15 6l-6 6 6 6" /></svg>
);
export const CheckCircle: IconComponent = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M8.5 12.5l2.5 2.5 4.5-5" />
  </svg>
);
export const XCircle: IconComponent = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M9 9l6 6M15 9l-6 6" />
  </svg>
);
export const InfoCircle: IconComponent = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8h.01M11 12h1v5h1" />
  </svg>
);
export const PlusIcon: IconComponent = (p) => (
  <svg {...base} {...p}><path d="M12 5v14M5 12h14" /></svg>
);
export const SearchIcon: IconComponent = (p) => (
  <svg {...base} {...p}>
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-3.5-3.5" />
  </svg>
);
export const DocIcon: IconComponent = (p) => (
  <svg {...base} {...p}>
    <path d="M6 3h9l5 5v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" />
    <path d="M15 3v5h5" />
    <path d="M9 13h6M9 17h4" />
  </svg>
);
export const SettingsIcon: IconComponent = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19 12a7 7 0 0 0-.1-1.2l2-1.6-2-3.4-2.4.9a7 7 0 0 0-2.1-1.2L14 3h-4l-.4 2.5a7 7 0 0 0-2.1 1.2L5.1 5.8l-2 3.4 2 1.6A7 7 0 0 0 5 12c0 .4 0 .8.1 1.2l-2 1.6 2 3.4 2.4-.9a7 7 0 0 0 2.1 1.2L10 21h4l.4-2.5a7 7 0 0 0 2.1-1.2l2.4.9 2-3.4-2-1.6c.1-.4.1-.8.1-1.2Z" />
  </svg>
);
export const MicIcon: IconComponent = (p) => (
  <svg {...base} {...p}>
    <rect x="9" y="3" width="6" height="11" rx="3" />
    <path d="M5 11a7 7 0 0 0 14 0M12 18v3" />
  </svg>
);
